import React from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import { useHistory } from 'react-router-dom'

const DeleteTaskMenuItem = ({ taskType = '', readOnly, task, order, refetch }) => {
  const { formatMessage } = useIntl()
  const history = useHistory()

  const onClick = () => {
    if (confirm(formatMessage(messages.confirmPrompt, {taskType:taskType}))) {
      fetch(`/ordertask/delete.json?taskid=${task.uid}`, { 
        method: 'DELETE'
      })
      .then((response) => response.json())
      .then(({ status, message }) => {
        if (status === 'success') {
          toastr.success(formatMessage(messages.success, {taskType:taskType}))
          refetch()
          history.push(`../`)
        } else {
          toastr.error(message)
        }
      })
      .catch((error) => toastr.error(error))
    }
  }

  return (
    <React.Fragment>
      <Menu.Item disabled>
        {(props) => (
          <MenuButton {...props} disabled className="cursor-help">
            Danger zone
          </MenuButton>
        )}
      </Menu.Item>
      <Menu.Item disabled={readOnly}>
        {(props) => (
          <MenuButton state="negative" disabled={readOnly} onClick={onClick} {...props}>
            { formatMessage(messages.label, {taskType:taskType}) }
          </MenuButton>
        )}
      </Menu.Item>
    </React.Fragment>
  )
}

export default DeleteTaskMenuItem
